import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { authApi } from '../..'

type RegularResponse = {
  status: 'pending' | 'expired' | 'rejected'
  expires_at: string
}

type ApprovedResponse = {
  status: 'approved'
  otp: string
}

export type CheckApprovalStatusResponse = RegularResponse | ApprovedResponse

export type CheckApprovalStatusRequest = {
  sessionId: string
}

export const checkApprovalStatus = async (
  request: CheckApprovalStatusRequest
) => {
  const response = await authApi.get<CheckApprovalStatusResponse>(
    `/2fa/login-status/${request.sessionId}`
  )

  return response.data
}

export const CHECK_APPROVAL_STATUS_QUERY_KEY = 'checkApprovalStatus'

export const useCheckApprovalStatus = (
  request: CheckApprovalStatusRequest,
  options?: ExtendableQueryOptions<CheckApprovalStatusResponse>
) => {
  return useQuery({
    queryKey: [CHECK_APPROVAL_STATUS_QUERY_KEY, request],
    queryFn: () => checkApprovalStatus(request),
    ...options
  })
}
